import React from 'react'
import { getDiscountPercentage, Product } from '@ecommerce/shared'
import { DetailViewProduct } from '../ProductDetail/types'

interface ConnectifProductTagsProps {
  product: Product | DetailViewProduct
  url?: string
}

const ConnectifProductTags: React.FC<ConnectifProductTagsProps> = ({ product, url }) => {
  if (!product) return null

  const formatPrice = (price: number | undefined): number => {
    if (price === undefined) return 0
    return price
  }

  const discountedAmount =
    product.rawPrice && product.price ? formatPrice(product.rawPrice) - formatPrice(product.price) : 0

  const discountedPercentage = getDiscountPercentage(product.price, product.rawPrice)

  return (
    <div className="cn-product-tags-container">
      <div
        className="cn_product_visited"
        aria-hidden
        style={{
          position: 'absolute',
          height: '1px',
          width: '1px',
          overflow: 'hidden',
          clip: 'rect(1px, 1px, 1px, 1px)',
        }}
      >
        <span className="product_id">{product.skuCode}</span>
        <span className="name">{product.title}</span>
        <span className="url">{url}</span>
        <span className="unit_price">{formatPrice(product.price)}</span>
        <span className="unit_price_original">{formatPrice(product.rawPrice)}</span>
        <span className="availability">{!product.unavailable ? 'InStock' : 'OutOfStock'}</span>
        <span className="discounted_amount">{discountedAmount}</span>
        <span className="discounted_percentage">{discountedPercentage}</span>
        {product.image && <span className="image_url">{product.image}</span>}
        {product.brandName && <span className="brand">{product.brandName}</span>}
        {product.categoryName && <span className="category">{product.categoryName}</span>}
        {product.productDescription && <span className="description">${product.productDescription}</span>}
      </div>
    </div>
  )
}

export default ConnectifProductTags
